/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import withRouter from "../WithRouter";
//Packages
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { isAuthenticatedTutor } from "./services/TutorAuth"; //import auth
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";
import ReturnButton from "../common/ReturnButton";

const AwardParticipant = (props) => {
  const [Awards, setAwards] = useState([]);
  const [AwardList, setAwardList] = useState([]);
  const [Participant, setParticipant] = useState({});
  const [SelectedAward, setSelectedAward] = useState("");
  // Error and Click Handling
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  const participantid = props.params.participantid;
  const prevParticipantid = useRef(); //Reference the previous ID to ensure new get request if it changes.
  // Get details
  useEffect(async () => {
    prevParticipantid.current = participantid; // Assign Refs Value to current load
    const awardsRequest = await axios.get(`/api/tutor/report_cards/awards`, {
      withCredentials: true,
    });
    const participantRequest = await axios.get(`/api/tutor/report_cards/participant_award/${participantid}`, {
      withCredentials: true,
    });
    setParticipant(participantRequest.data);
    setAwards(participantRequest.data.Awards);
    return setAwardList(awardsRequest.data);
  }, [participantid]);

  //Fetch new data as required
  const fetchNewData = async () => {
    const participantRequest = await axios.get(`/api/tutor/report_cards/participant_award/${participantid}`, {
      withCredentials: true,
    });
    setParticipant(participantRequest.data);
    return setAwards(participantRequest.data.Awards);
  };

  // Push Award to participant
  const pushAward = async (e) => {
    e.preventDefault();
    setSubmitClicked(true);
    const requestPush = await axios.put(
      `/api/tutor/report_cards/push_award/`,
      {
        participantid,
        awardid: SelectedAward,
      },
      {
        withCredentials: true,
      }
    );
    if (requestPush.status === 200) {
      setSubmitClicked(false);
      setSuccessMessage("Successfully awarded participant.");
      return fetchNewData();
    } else {
      setSubmitClicked(false);
      return setErrorMessage("There was a problem with your request.");
    }
  };

  const revokeAward = async (awardid, e) => {
    e.preventDefault();
    setSubmitClicked(true);
    const requestPull = await axios.delete(
      `/api/tutor/report_cards/pull_award/`,
      { data: { participantid, awardid } },
      {
        withCredentials: true,
      }
    );
    if (requestPull.status === 200) {
      setSubmitClicked(false);
      setSuccessMessage("Award successfully revoked.");
      return fetchNewData();
    } else {
      setSubmitClicked(false);
      return setErrorMessage("There was a problem with your request.");
    }
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='AwardParticipant'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticatedTutor() ? (
          <Container>
            {AwardList.length > 0 ? (
              <>
                <Row className='text-center mb-3'>
                  <Col>
                    <h1>{Participant.First_Name + " " + Participant.Last_Name}</h1>
                    <ReturnButton/>
                  </Col>
                </Row>
                <Row className='mt-3 mb-3 text-center'>
                  <Col>
                    <h3>Attach Award</h3>
                    <p>
                      Attaching an award here makes it show up in the customer dashboard against the
                      participant&apos;s awards.
                    </p>
                    <Form onSubmit={pushAward} className='p-3 mt-3 mb-3 shadow border'>
                      <Form.Label>Award List</Form.Label>
                      <Form.Control
                        as='select'
                        value={SelectedAward}
                        onChange={(e) => setSelectedAward(e.target.value)}
                        className='border'
                        custom
                      >
                        <option value='' disabled defaultValue>
                          Select Award
                        </option>
                        {AwardList.map((AwardItem) => (
                          <option key={AwardItem._id} value={AwardItem._id}>
                            {AwardItem.Type}
                          </option>
                        ))}
                      </Form.Control>
                      <Button
                        type='submit'
                        variant='success'
                        className='w-100 mt-3 mb-3'
                        disabled={submitClicked}
                      >
                        Attach Award
                      </Button>
                    </Form>
                  </Col>
                </Row>
                <Row>
                  <Col sm='12'>
                    <div>
                      <StatusBlock
                        errorMessage={errorMessage}
                        successMessage={successMessage}
                        dismissMessages={dismissMessages}
                      />
                    </div>
                  </Col>
                </Row>
                {Awards.length > 0 && (
                  <Row className='text-center'>
                    <Col sm='12'>
                      <h3>Issued Awards</h3>
                      {Awards.map((award) => (
                        <div key={award._id} className='mx-1 mt-3 p-2 shadow text-center border'>
                          <h4>{award.Type}</h4>
                          <p className='smallprint'>{award.ShortDescription}</p>
                          <Button
                            type='submit'
                            variant='warning'
                            className='mt-3 mb-3 w-100'
                            onClick={(e) => revokeAward(award._id, e)}
                          >
                            Revoke
                          </Button>
                        </div>
                      ))}
                    </Col>
                  </Row>
                )}
              </>
            ) : (
              <Row className='text-center'>
                <Col>
                  <h3>No awards set up...</h3>
                  <p>
                    You must set up awards in the awards tab if you wish to use this functionality.
                  </p>
                  <ReturnButton/>
                </Col>
              </Row>
            )}
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};
export default withRouter(AwardParticipant);
